import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./route-progress-bar.scss";

function RouteProgressBar() {
    const location = useLocation();
    const [animKey, setAnimKey] = useState(0);

    useEffect(() => {
        setAnimKey((k) => k + 1);
    }, [location.pathname, location.search]);

    return <div key={animKey} className="route-progress-bar" aria-hidden="true" />;
}

export default RouteProgressBar;
